export default "__VITE_ASSET__8W3vZk6g__"